import {useEffect, useRef, useState} from 'react';
import {useDepartament} from "hooks/useDepartament";
import Search from "components/Departament/Search";
import Form from "components/Departament/Form";
import Table from "components/Departament/Table";
import SpinnerBootrap from 'components/SpinnerBootrap';

function Departament(){
 const {
    departaments, 
    loading, 
    page, 
    totalPages, 
    status, 
    deleteDepartament, 
    updateDepartament, 
    createDepartament, 
    getDepartaments, 
    setPage,
    itemsPerPage,
    setItemsPerPage,
    allDepartaments,
} = useDepartament();


const [isSearched, setIsSearched] = useState({
    search: '',
    option: '',
    state: false
})

 const searchFormRef = useRef();

 const resetSearch = () => {
    setIsSearched({
        search: '',
        option: '',
        state: false
    })
    searchFormRef.current?.reset();
 }

 useEffect(() => {
    if(status !== 401 ) return
    localStorage.removeItem('token')
    window.location.href="/login"
 }, [status])

 return (
 <div className="container">
     <div className="row my-md-4">
         <h4 className="d-flex justify-content-center">Mantenedor de Departamentos</h4>
         <div className="col-12">
             <Search getDepartaments={getDepartaments} setIsSearched={setIsSearched} formRef={searchFormRef}/>
         </div>
         <div className="col-12">
             <Form createDepartament={createDepartament} updateDepartament={updateDepartament} setIsSearched={setIsSearched}/>
         </div>
         <div className="col-12">
             {loading && <SpinnerBootrap/>}
             <Table 
                departaments={departaments}
                getDepartaments={getDepartaments}
                deleteDepartament={deleteDepartament}
                totalPages={totalPages}
                setPage={setPage}
                page={page}
                isSearched={isSearched}
                setIsSearched={setIsSearched}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                hasSearched={isSearched.state}
                resetSearch={resetSearch}
                totalDepartaments={allDepartaments.length ?? 0}
             />
         </div>
     </div>
 </div>
 )
}

export default Departament